import React, { useEffect, useState } from 'react';
import { Table, Button, Tooltip, Tag, Typography, Popconfirm, Spin, Space } from 'antd';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { GrCompliance } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import deleteDataById from '../../../hooks/admin/deleteDataById';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const GeneralQuery = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [queries, setQueries] = useState([]);
    const user = JSON.parse(localStorage.getItem('admin'));
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchQueries = async () => {
            try {
                const baseUrl = process.env.REACT_APP_APIURL;
                const res = await fetch(`${baseUrl}/admin/getallgeneralquery`, {
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': `Bearer ${user.token}`
                    }
                });
                const response = await res.json();
                if (response.status_code === 200) {
                    setQueries(response.data);
                }
            } catch (error) {
                toast.error('Failed to load queries.');
            }
        };

        fetchQueries();
    }, []);

    const selectItemToEdit = (id) => {
        navigate('/admin/update_query', { state: id });
    };

    const deleteItem = async (id) => {
        setLoading(true);
        const response = await deleteDataById('admin/deletegeneralquery', id);
        if (response.status_code === 200) {
            setQueries(prev => prev.filter(item => item.id !== id));
            toast.success(t("delete_success"));
        } else {
            toast.error(response?.message || response?.err || "Delete failed.");
        }
        setLoading(false);
    };

    const columns = [
        {
            title: t("Name"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t("l_email"),
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: t("Cus_phone"),
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: t("Query"),
            dataIndex: 'query',
            key: 'query',
        },
        {
            title: t("all_product_dataTable6"),
            key: 'resolution',
            render: (_, record) =>
                !record.resolution ? (
                    <Tag color="warning">{t("Pending")}</Tag>
                ) : (
                    <span>{record.resolved_on?.slice(0, 10)}</span>
                )
        },
        {
            title: t("Options"),
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Tooltip title={t("Edit")}>
                        <Button
                            type="text"
                            icon={!record.resolution ? <AiOutlineEdit /> : <GrCompliance />}
                            onClick={() => selectItemToEdit(record.id)}
                        />
                    </Tooltip>
                    <Popconfirm
                        title={t("delete_alert_title")}
                        description={t("delete_alert_des")}
                        onConfirm={() => deleteItem(record.id)}
                        okText={t("yes")}
                        cancelText={t("no")}
                    >
                        <Tooltip title={t("Delete")}>
                            <Button
                                danger
                                type="text"
                                icon={<AiOutlineDelete />}
                            />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            )
        },
    ];

    return (
        <div>
            <Helmet>
                <title>{t('Admin')} - {t("Admin_query")}</title>
            </Helmet>
            <Title level={5}>{t("Query_all")}</Title>
            <div className="my-5 bg-white border rounded p-4">
                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table
                        columns={columns}
                        dataSource={queries}
                        rowKey="id"
                        pagination={{ pageSize: 10 }}
                    />
                )}
            </div>
        </div>
    );
};

export default GeneralQuery;
